import { render, staticRenderFns } from "./DialogPlayGamesMobile.vue?vue&type=template&id=64e556c8"
import script from "./DialogPlayGamesMobile.vue?vue&type=script&lang=js"
export * from "./DialogPlayGamesMobile.vue?vue&type=script&lang=js"
import style0 from "./DialogPlayGamesMobile.vue?vue&type=style&index=0&id=64e556c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports